import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Controls from "../controls/Controls";
import { useForm, Form } from "../customHelpers/useForm";
import PurchaseProduct from "../../actions/purchaseProduct";

const initialFValues = {
  id: 0,
  price: "",
  quantity: "",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "80%",
      margin: theme.spacing(1),
    },
  },
}));

const UpdatePurchaseListForm = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAllProducts,
  openPopupUpdate,
  edite,
}) => {
  const classes = useStyles();
  const { updatePurchaseList } = PurchaseProduct();

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("price" in fieldValues)
      temp.price = fieldValues.price ? "" : "This field is required.";
    if ("quantity" in fieldValues)
      temp.quantity = fieldValues.quantity ? "" : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      updatePurchaseList(values,values.id).then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Purchase list updated successfully",
            type: "success",
          });
          setOpenPopup(false);
          getAllProducts();
        }
      });
    }
  };

  return (
    <Form className={classes.root} onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="price"
            label="Price"
            value={values.price}
            onChange={handleInputChange}
            error={errors.price}
          />
          <Controls.Input
            name="quantity"
            label="Quantity"
            value={values.quantity}
            onChange={handleInputChange}
            error={errors.quantity}
          />
          <div>
            <Controls.Button
              type="submit"
              text="Submit"
              variant="contained"
              className="Button"
            />
            <Controls.Button
              text="Reset"
              color="default"
              variant="contained"
              className="Button"
              onClick={resetForm}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default UpdatePurchaseListForm;
